<template>
    <div class="">
        <div class="m-b-1">
            <p><b>{{ i18n.filter_cena }}</b></p>
            <vue-slider v-model="price" :enable-cross="false" :tooltip="'none'" :contained="true" :min="0"
                        :max="max_price"
                        :interval="1"/>
            <p class="">{{price[0]}} € - {{price[1]}} €</p>
        </div>

        <div v-for="(category, categoryIndex) in categories" :key="category.id" v-if="category.tags.length">
            <div class="m-b-1">
                <p><b>{{ category.name[lang] }}</b></p>

                <div
                    v-for="tag in category.tags"
                    :key="tag.id"
                >
                    <a
                        href="javascript:;"
                        class="no-underline"
                        @click="toggle_tag(tag.id)"
                        :class="{'orange-link': active_tags.includes(tag.id), 'green-link': !active_tags.includes(tag.id)}"
                    >
                        <small>
                            <template v-if="active_tags.includes(tag.id)"><span class="material-icons">
check_box
</span></template>
                            <template v-else><span class="material-icons">
check_box_outline_blank
</span></template>
                            {{ tag.name[lang] }}
                        </small>
                    </a>
                </div>
                <div>
                    <a href="javascript:;" :class="{'orange-link': active_categories.includes(categoryIndex), 'green-link': !active_categories.includes(categoryIndex)}" class="no-underline" @click="toggleCategory(categoryIndex)"> <small>
                        <template v-if="active_categories.includes(categoryIndex)"><span class="material-icons">
check_box
</span></template>
                        <template v-else><span class="material-icons">
check_box_outline_blank
</span></template>
                        {{ i18n.vsetky }}
                    </small></a>
                </div>
            </div>
        </div>
        <div class="has-text-centered">
            <button type="button" class="button button-small button-blue" @click="submit()">
                {{ i18n.filtrovat }}
            </button>
            <div class="mt-1">
                <a :href="this.url" class="blue-link"><small>{{ i18n.zrusit_filtrovanie }}</small></a>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'

    export default {
        components: {
            VueSlider
        },
        props: {
            categories: Array,
            max_price: Number,
            filter: Object,
            url: String
        },
        data: function () {
            return {
                active_tags: this.filter['tags'] ? this.filter['tags'] : [],
                price: [this.filter['min_price'], this.filter['max_price']],
                active_categories: [],
	              lang: document.documentElement.lang,
                i18n: i18n
            };
        },
        methods: {
            delete_tag(id) {
                if (this.active_tags.includes(id)) {
                    this.active_tags.splice(this.active_tags.indexOf(id), 1);
                }
            },
            add_tag(id) {
                if (!this.active_tags.includes(id)) {
                    this.active_tags.push(id);
                }
            },
            toggleCategory(index) {
                this.active_categories.includes(index) ? this.active_categories.splice(this.active_categories.indexOf(index), 1) : this.active_categories.push(index);

                let isActive = this.active_categories.includes(index);

                this.categories[index].tags.map((tag) => {
                    if(isActive) {
                        this.add_tag(tag.id);
                    } else {
                        this.delete_tag(tag.id);
                    }
                });
            },
            toggle_tag(id) {
                this.active_tags.includes(id) ? this.delete_tag(id) : this.add_tag(id);
            },
            submit() {
                let url = new URL(document.URL);
                let sort = '';
                let newURL = new URL(url.href.split('?')[0]);
                url.searchParams.forEach(function (value, key) {
                    if(key === 'sort') {
                        sort = value;
                    }
                });

                if (this.active_tags.length) {
                    this.active_tags.forEach((item) => {
                        newURL.searchParams.append('tags[]', item);
                    });
                }

                newURL.searchParams.set('min_price', this.price[0]);
                newURL.searchParams.set('max_price', this.price[1]);
                newURL.searchParams.set('sort', sort);
                newURL.searchParams.set('page', 1);

                let newUrl = newURL.href;

                if (!newUrl.includes('#filter')) {
                    newUrl += '#filter';
                }

                window.location.href = newUrl;
            },
        }
    };
</script>

<style>
    .vue-slider-process, .vue-slider:hover .vue-slider-process {
        background-color: #307A40;
    }

    .vue-slider-dot-handle, .vue-slider:hover .vue-slider-dot-handle, .vue-slider-dot-handle:hover, .vue-slider:hover .vue-slider-dot-handle:hover {
        border-color: #307A40;
    }
</style>
